import React, { useState } from 'react';
import axios from 'axios';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { useI18n, useTranslation } from '../i18n';
import API_BASE_URL from '../config/api';

const PasswordReset = () => {
  const { t } = useTranslation();
  const { language } = useI18n();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
   await axios.post(
        `${API_BASE_URL}/auth/forgot-password`,
        { email },
        { headers: { 'Accept-Language': language } }
      );
      setMessage(t('passwordReset.success'));
    } catch (error) {
      setMessage(error.response?.data?.error || t('passwordReset.error'));
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
        <LanguageSwitcher dark />
      </div>

      <h2>{t('passwordReset.title')}</h2>
      <form onSubmit={handleSubmit}>
        <label>{t('common.email')}:</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <button type="submit">{t('common.send')}</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default PasswordReset;
